import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19.476 12.773H4.523a.773.773 0 1 1 0-1.546h14.953a.773.773 0 1 1 0 1.546z"
}), 'Remove');